/**
 * User-facing labels for portal-submitted claims list (`GET /api/claims/submitted`).
 * @module claims/submittedClaimDisplay
 */

/** Maps persisted `source` (FNOL submit kind) to a loss-type label for the claims list. */
export function submittedClaimLossTypeLabel(source: string): string {
  switch (source) {
    case 'windscreen_fnol':
      return 'Windscreen or glass'
    case 'weather_fnol':
      return 'Weather'
    case 'theft_fnol':
      return 'Theft'
    case 'fire_fnol':
      return 'Fire'
    case 'malicious_damage_fnol':
      return 'Malicious damage'
    case 'other_loss_fnol':
      return 'Other'
    case 'multi_vehicle_fnol':
      return 'Multi-vehicle collision'
    case 'single_vehicle_fnol':
      return 'Single vehicle collision'
    default:
      return 'Claim'
  }
}

/** Formats portal submission timestamp for display (en-AU, local calendar date). */
export function formatSubmittedClaimSubmissionDate(iso: string): string {
  const trimmed = iso.trim()
  if (!trimmed) return '—'
  const date = new Date(trimmed)
  if (Number.isNaN(date.getTime())) return trimmed
  return date.toLocaleDateString('en-AU', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  })
}

/** Title-case a Wilbur status/decision token for the claims list. */
export function formatSubmittedClaimStatusLabel(value: string | null | undefined): string {
  const trimmed = (value ?? '').trim()
  if (!trimmed) return '—'
  return trimmed
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ')
}
